import { Check, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

export const inr = (n) => { const v = Number(n || 0); return `₹${v.toLocaleString("en-IN", { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 })}`; };

export const CycleToggle = ({ cycle, setCycle }) => (
  <div className="inline-flex rounded-full border bg-white p-1 text-sm" data-testid="billing-cycle-toggle">
    {[["monthly", "Monthly"], ["annual", "Annual · 2 months free"]].map(([k, l]) => (
      <button key={k} onClick={() => setCycle(k)} data-testid={`cycle-${k}`}
        className={`px-4 py-1.5 rounded-full transition-colors ${cycle === k ? "bg-[#48217A] text-white" : "text-[#3B4A63] hover:bg-slate-50"}`}>{l}</button>
    ))}
  </div>
);

function PlanCard({ id, p, prev, cycle, labels, current, onSelect, busy, cta }) {
  const price = p[cycle];
  const feats = prev ? p.features.filter((f) => !prev.features.includes(f)) : p.features;
  return (
    <div className={`qt-card p-6 flex flex-col relative ${p.recommended ? "ring-2 ring-[#48217A]" : ""}`} data-testid={`plan-card-${id}`}>
      {p.recommended && <span className="absolute -top-3 left-6 bg-[#48217A] text-white text-[11px] font-semibold px-2.5 py-0.5 rounded-full inline-flex items-center gap-1"><Sparkles className="h-3 w-3" />Recommended</span>}
      <div className="font-display text-xl font-bold text-[#172238]">{p.name}</div>
      <p className="text-sm text-[#5A6B87] mt-1 min-h-[40px]">{p.tagline}</p>
      <div className="mt-4">
        {p.starting && <div className="text-[11px] uppercase tracking-wider text-[#5A6B87]">Starting</div>}
        <span className="font-display text-3xl font-extrabold text-[#48217A]" data-testid={`plan-price-${id}`}>{inr(price)}</span>
        <span className="text-sm text-[#5A6B87]">/{cycle === "annual" ? "year" : "month"} + GST</span>
      </div>
      <div className="text-xs text-[#5A6B87] mt-1">Per laboratory site · {p.editors ? `up to ${p.editors} editor accounts` : "editor accounts as agreed"} · {p.ai_credits} AI credits/month</div>
      {prev && <div className="mt-4 text-[12px] font-semibold text-[#172238]">Everything in {prev.name}, plus:</div>}
      <ul className={`${prev ? "mt-2" : "mt-4"} space-y-1.5 text-[13px] flex-1`}>
        {feats.map((f) => <li key={f} className="flex gap-2"><Check className="h-4 w-4 text-[#2E9B65] shrink-0 mt-0.5" />{labels[f]}</li>)}
      </ul>
      <Button disabled={busy || current} onClick={() => onSelect(id, p)} data-testid={`plan-select-${id}`}
        className={`mt-5 w-full ${p.recommended ? "bg-[#48217A] hover:bg-[#3B1A66]" : ""}`} variant={p.recommended ? "default" : "outline"}>
        {current ? "Current plan" : cta(p)}
      </Button>
    </div>
  );
}

export function PlanCards({ pricing, cycle, current, onSelect, busy, cta }) {
  return (
    <div className="grid md:grid-cols-3 gap-5 pt-3">
      {Object.entries(pricing.plans).map(([id, p], i, all) => (
        <PlanCard key={id} id={id} p={p} prev={i ? all[i - 1][1] : null} cycle={cycle} labels={pricing.feature_labels} current={current === id} onSelect={onSelect} busy={busy}
          cta={cta || ((x) => (x.checkout ? `Choose ${x.name}` : "Talk to us"))} />
      ))}
    </div>
  );
}

export function SprintCard({ s, onBuy, busy, cta = "Buy Launch Sprint", owned }) {
  return (
    <div className="qt-card p-6 grid md:grid-cols-[1fr_auto] gap-5 items-center" data-testid="launch-sprint-card">
      <div>
        <div className="qt-eyebrow mb-1">One-time · {s.days}-day readiness package</div>
        <div className="font-display text-xl font-bold text-[#172238]">{s.name}</div>
        <ul className="mt-3 grid sm:grid-cols-2 gap-x-6 gap-y-1 text-[13px]">{s.includes.map((x) => <li key={x} className="flex gap-2"><Check className="h-4 w-4 text-[#2E9B65] shrink-0 mt-0.5" />{x}</li>)}</ul>
        <p className="text-xs text-[#5A6B87] mt-3">Billed separately from the subscription, which continues your access afterwards.</p>
      </div>
      <div className="md:text-right">
        <div className="font-display text-3xl font-extrabold text-[#48217A]" data-testid="sprint-price">{inr(s.price)}</div>
        <div className="text-xs text-[#5A6B87] mb-3">per laboratory site + GST{s.price_max ? ` · scope up to ${inr(s.price_max)}` : ""}</div>
        <Button disabled={busy || owned} onClick={onBuy} className="bg-[#2E9B65] hover:bg-[#258254]" data-testid="sprint-buy-btn">{owned ? "Sprint active" : cta}</Button>
      </div>
    </div>
  );
}
